import React from "react";
import fastwash from "../assets/images/Produits/WashBasic.jpg";
import fastwashpro from "../assets/images/Pro.png";
import fastwashallinone from "../assets/images/AllinOne.png";
import shower from "../assets/images/Produits/letshower.png";
import FastWashKiosque from "../assets/images/Produits/FastWashKiosque.jpeg";
import aspirateur from "../assets/images/Produits/Aspirateur (2).png";
import gonfleur from "../assets/images/Gonfleur2.png";
import detergent from "../assets/images/produitdétergent.jpeg";
import destributeur from "../assets/images/Distributeur.png";
import accessoire1 from "../assets/images/Produits/accessoire1.jpg";
import accesoire2 from "../assets/images/Produits/accessoire2.jpg";
import accesoire3 from "../assets/images/Produits/accesoire3.jpg";
import recyclage from "../assets/images/recycliqu.jpg";
import machine from "../assets/images/machinelaver.png";
import sech from "../assets/images/secheur.png";
import frappeTapis from "../assets/images/FrappeT.png";

type Product = {
  image: string;
  title: string;
  description: string;
  href: string;
};

const ProductCard: React.FC<Product> = ({ image, title, description, href }) => (
<div className="group flex w-full max-w-sm flex-col overflow-hidden rounded-2xl bg-white border border-gray-100 shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
<div className="relative h-52 sm:h-60 md:h-64 w-full overflow-hidden bg-gray-100">
        <img
        src={image}
        alt={title}
className="h-full w-full object-contain bg-white transition-transform duration-500 group-hover:scale-110"      />
      <div className="absolute inset-0 bg-gradient-to-t from-blue-900/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
    </div>

    <div className="flex flex-1 flex-col p-6">
      <div className="mb-3 h-1 w-10 rounded-full bg-yellow-400 group-hover:w-16 transition-all duration-300"></div>
      <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">{title}</h3>
<p className="text-gray-600 text-xs sm:text-sm leading-relaxed whitespace-pre-line flex-1">
          {description}
      </p>
      <a
        href={href}
        className="mt-5 inline-flex items-center justify-center gap-2 rounded-full bg-blue-600 px-4 sm:px-6 py-2.5 text-[11px] sm:text-xs font-bold uppercase tracking-wide text-white shadow-md transition-all duration-300 hover:bg-blue-700 hover:shadow-blue-500/40 hover:gap-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        En savoir plus
        <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </a>
    </div>
  </div>
);

const SectionHeader: React.FC<{ eyebrow: string; title: string }> = ({ eyebrow, title }) => (
  <div className="flex flex-col items-center mb-8">
    <span className="text-yellow-500 text-xs font-bold tracking-[0.2em] uppercase mb-2">
      {eyebrow}
    </span>
<h2 className="text-xl sm:text-2xl md:text-3xl font-black uppercase text-gray-900 text-center px-2">
        {title}
    </h2>
    <div className="mt-4 h-1.5 w-16 rounded-full bg-gradient-to-r from-blue-600 to-yellow-400"></div>
  </div>
);

const Produits: React.FC = () => {
  const selfServiceProducts: Product[] = [
    {
      image: fastwash,
      title: "Fast Wash Basic",
      description:
        "Découvrez le Fast Wash Basic, une solution performante pour un lavage automobile rapide et efficace au quotidien. Conçu pour allier performance et praticité, ce système de lavage moderne répond aux besoins des stations de lavage en matière de qualité et de rapidité.",
      href: "/product-details/fastwashbasic",
    },
    {
      image: fastwashpro,
      title: "Fast Wash Pro",
      description:
        "Découvrez l’efficacité maximale avec Fast Wash Pro. Conçu pour offrir des performances supérieures et une durabilité exceptionnelle, ce système de lavage avancé redéfinit les standards du lavage automobile moderne.",
      href: "/product-details/fastwashpro",
    },
    {
      image: shower,
      title: "let's Shower",
      description:
        "Let’s Shower est un système de lavage self-service conçu pour offrir un nettoyage extérieur autonome des véhicules. Il permet aux utilisateurs d’accéder facilement aux équipements de lavage afin d’assurer un entretien rapide, pratique et flexible.",
      href: "/product-details/letsshower",
    },
    {
      image: fastwashallinone,
      title: "Fast Wash All-in-One",
      description:
        "Fast Wash All-in-One offre une solution complète et pratique pour le lavage automobile.Il combine lavage, séchage et fonctionnalités avancées dans une seule unité, idéale pour répondre aux besoins des stations modernes.",
      href: "/product-details/fastwashallinone",
    },
  ];

  const complementaryProducts: Product[] = [
    {
      image: aspirateur,
      title: "Aspirateur",
      description:
        "Découvrez l'Aspirateur Self Service, une solution pratique conçue pour le nettoyage intérieur des véhicules. Performant et facile à utiliser, il permet d’éliminer efficacement poussières, saletés et débris afin d’offrir aux utilisateurs un habitacle propre et soigné.",
      href: "/product-details/aspirateurselfservice",
    },
    {
      image: gonfleur,
      title: "Gonfleur Air",
      description:
        "Le Gonfleur Air Self Service permet de vérifier et ajuster facilement la pression des pneus.Fiable et simple d’utilisation, il assure un gonflage précis pour plus de sécurité.Conçu pour le libre-service, il fonctionne de manière autonome dans les stations de lavage.",
      href: "/product-details/gonfleurairselfservice",
    },
    {
      image: destributeur,
      title: "Distributeur d'Eau d'Essuie-Glace",
      description:
        "Le Distributeur d’Eau d’Essuie-Glace permet de nettoyer facilement le pare-brise à tout moment.Simple et pratique, il assure une visibilité optimale pour une conduite plus sûre.",
      href: "/product-details/distributeureauessuieglace",
    },
    {
      image: recyclage,
      title: "Système de Recyclage d'Eau",
      description:
        "Le Système de Recyclage d’Eau permet de réutiliser efficacement l’eau utilisée lors du lavage.Écologique et performant, il contribue à la réduction de la consommation d’eau tout en garantissant un bon résultat de nettoyage.",
      href: "/product-details/recyclageeau",
    },
    {
  image: frappeTapis,
  title: "Frappe Tapis",
  description:
    "Le Frappe Tapis est un équipement essentiel pour le nettoyage en profondeur des tapis de voiture. Il permet d’éliminer efficacement la poussière et les saletés incrustées.",
  href: "/product-details/frappetapis",
},
  ];

  const laundryProducts: Product[] = [
  {
    image: machine,
    title: "Machine à Laver",
    description:
      "Conçue pour les laveries self-service, cette machine à laver grande capacité offre des performances de lavage exceptionnelles, une faible consommation d’énergie et une grande robustesse. Adaptée à une utilisation intensive, elle garantit efficacité, fiabilité et confort d’utilisation au quotidien.",
    href: "/product-details/machinealaverprofessionnelle",
  },
  {
    image: sech,
    title: "Sèche-Linge",
    description:
      "Le sèche-linge assure un séchage rapide, homogène et performant pour d’importantes quantités de linge. Conçu pour les laveries libre-service, il offre une excellente efficacité et une durabilité optimale, garantissant un usage intensif et une performance constante.",
    href: "/product-details/sechelingeprofessionnel",
  },
];
  return (
    <div className="min-h-screen bg-gray-50">

      {/* HERO */}
<div className="relative bg-gradient-to-br from-blue-700 via-blue-700 to-blue-900 pt-28 sm:pt-32 md:pt-40 pb-16 sm:pb-20 md:pb-28 px-4 sm:px-6 text-center overflow-visible">

        <div className="relative z-10 max-w-3xl mx-auto">
          <span className="inline-flex items-center gap-2 text-yellow-400 text-xs font-bold tracking-[0.25em] uppercase mb-4">
            <span className="w-8 h-px bg-yellow-400"></span>
            Catalogue J-Tronics
            <span className="w-8 h-px bg-yellow-400"></span>
          </span>

<h1 className="text-3xl sm:text-4xl md:text-5xl xl:text-6xl font-black text-white mb-6">
              Nos Produits
          </h1>

<p className="text-blue-100/90 text-sm sm:text-base md:text-lg leading-relaxed px-2">
Découvrez notre gamme complète de solutions professionnelles dédiées au lavage automobile et aux laveries self-service, conçues pour allier performance, fiabilité et innovation.          </p>
        </div>
      </div>

<div className="px-4 sm:px-6 pb-20 sm:pb-28 lg:pb-32">

        {/* Section Fast-Wash */}
<section className="pt-10">
            <SectionHeader eyebrow="Lavage autonome" title="Solutions de Lavage Self-Service" />

<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 sm:gap-8 lg:gap-10 justify-items-center">
              {selfServiceProducts.map((product) => (
              <ProductCard key={product.title} {...product} />
            ))}
          </div>
        </section>

        {/* Section Produits Principaux */}
<section className="pt-8 sm:pt-10 lg:pt-12">
            <SectionHeader eyebrow="Pour aller plus loin" title="Équipements Complémentaires" />

<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 sm:gap-8 lg:gap-10 justify-items-center">
              {complementaryProducts.map((product) => (
              <ProductCard key={product.title} {...product} />
            ))}
          </div>
        </section>
      </div>
              {/* Section Laverie Self-Service */}
<section className="pt-12">
              <SectionHeader
            eyebrow="Laverie professionnelle"
            title="Équipements de Laverie Self-Service"
          />

<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 sm:gap-8 lg:gap-10 justify-items-center">
              {laundryProducts.map((product) => (
              <ProductCard key={product.title} {...product} />
            ))}
          </div>
        </section>
    </div>
  );
};

export default Produits;